import React, { Fragment, useCallback, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import cx from "classnames";
import { install } from "resize-observer";
import 'react-toastify/dist/ReactToastify.css';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { ToastContainer } from "react-toastify";

import { useSyncExternalStore } from "react";
import { setEnableClosedSidebar } from "reducers/ThemeOptions";
import Layout from "Layout/AppMain/Layout";
import { NavBlockProvider } from "helperFunctions/GuardNavigation";
if (!window.ResizeObserver) install();

let cachedSize = {
  width: document.body?.clientWidth || 0,
  height: document.body?.clientHeight || 0,
};

function subscribe(callback) {
  const observer = new ResizeObserver(([entry]) => {
    const { width, height } = entry.contentRect;

    if (width !== cachedSize.width || height !== cachedSize.height) {
      cachedSize = { width, height };
      requestAnimationFrame(() => callback());
    }
  });

  observer.observe(document.body);

  return () => observer.disconnect();
}

function getSnapshot() {
  return cachedSize;
}

function useWindowSize() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

// Class component remains mostly unchanged
class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
    };
  }

  render() {
    const {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
      windowWidth,
    } = this.props;

    return (
      <Fragment>
        <div
          className={cx(
            "app-container app-theme-" + colorScheme,
            { "fixed-header": enableFixedHeader },
            { "fixed-sidebar": enableFixedSidebar},
            { "fixed-footer": enableFixedFooter },
            { "closed-sidebar": enableClosedSidebar },
            {
              "closed-sidebar-mobile": closedSmallerSidebar ,
            },
            { "sidebar-mobile-open": enableMobileMenu },
            { "body-tabs-shadow-btn": enablePageTabsAlt }
          )}>
          <ProSidebarProvider>
            <NavBlockProvider>

              <Layout />
            </NavBlockProvider>
          </ProSidebarProvider>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});



const MainWithSize = (props) => {
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const isSmallScreen = width < 1250;

  useEffect(() => {
    dispatch(setEnableClosedSidebar(isSmallScreen));
  }, [isSmallScreen, dispatch]); 

  return <Main {...props} windowWidth={width} />;
};



export default connect(mapStateToProp)(MainWithSize);
